module.exports = __webpack_public_path__ + "static/media/sales-order-slide-4.61c8a4a8.jpg";